<template>
  <v-app>
    <go-top></go-top>
    
     <div>
       <!-- <video autoplay muted loop id="myVideo" class="banner">
            <source src="https://mdbootstrap.com/img/video/forest.mp4" type="video/mp4">
       </video> -->
       <carousel :autoplay="true" :items="1" :nav="false" :dots="false">
               <v-card class="banner" v-for="owl in mainOwl" :key="owl.id" :style="{backgroundImage: `url(${owl.src})`}">
                <!-- <h1 class="top-left">{{owl.name}}</h1> -->
               </v-card>
          </carousel>
     </div>
<!-- 
     <div style="margin-top:40px" class="res" v-if="owlCount.length > 0">
       <p style="text-align:center;text-transform: uppercase;color:#0b89ef;font-weight:bold">
         T r y  &nbsp;&nbsp;s o m e t h i n g  &nbsp;&nbsp;n e w  &nbsp;&nbsp;t o d a y
       </p>
       <h2 style="text-align:center;margin-top:-15px">
         Popular Tour Themes Around You
       </h2>
       <carousel :autoplay="true" :items="5" :nav="false">
               <v-card v-for="owl in owlCount" :key="owl.id" :style="{backgroundImage: `url(${owl.src})`}" class="tourtheme hvr" @click="thmpkg(owl)">
                <h2 class="themecap">{{owl.name}}</h2>
               </v-card>
          </carousel>
     </div>

          
         <div style="margin-top:10px" class="man" v-if="owlCount.length > 0">
       <p style="text-align:center;text-transform: uppercase;color:#0b89ef;font-weight:bold">
         T r y  &nbsp;&nbsp;s o m e t h i n g  &nbsp;&nbsp;n e w  &nbsp;&nbsp;t o d a y
       </p>
       <h4 style="text-align:center;margin-top:-15px">
         Popular Tour Themes Around You
       </h4>

       <carousel :autoplay="true" :items="1" :nav="false" :dots="false">
              <v-card v-for="owl in owlCount" :key="owl.id" :style="{backgroundImage: `url(${owl.src})`}" class="tourtheme hvr" @click="thmpkg(owl)">
             <h2 class="themecap">{{owl.name}}</h2>
         </v-card>
          </carousel>
       </div> -->
     
     <!-- ================================= -->
      <!-- ================================= -->

     <!-- <div style="margin-top:40px" class="res" v-if="owlCount1.length > 0">
       <p style="text-align:center;text-transform: uppercase;color:#0b89ef;font-weight:bold">
         T r a v e l  &nbsp;&nbsp;a n d  &nbsp;&nbsp;e a t  &nbsp;&nbsp;l i k e  &nbsp;&nbsp;a  &nbsp;&nbsp;l o c a l
       </p>
       <h2 style="text-align:center;margin-top:-15px">
         Top Most Trending Domstic Destinations
       </h2>
       <carousel :autoplay="true" :items="5" :nav="false">
               <v-card v-for="owl in owlCount1" :key="owl.id" :style="{backgroundImage: `url(${owl.src})`}" class="tourtheme hvr" @click="despkg(owl)">
                <h2 class="themecap">{{owl.name}}</h2>
               </v-card>
          </carousel>
     </div>

     <div style="margin-top:40px" class="man" v-if="owlCount1.length > 0">
       <p style="text-align:center;text-transform: uppercase;color:#0b89ef;font-weight:bold">
         T r a v e l  &nbsp;&nbsp;a n d  &nbsp;&nbsp;e a t  &nbsp;&nbsp;l i k e  &nbsp;&nbsp;a  &nbsp;&nbsp;l o c a l
       </p>
       <h4 style="text-align:center;margin-top:-15px">
         Top Most Trending Domstic Destinations
       </h4>
       <carousel :autoplay="true" :items="1" :nav="false" :dots="false">
               <v-card v-for="owl in owlCount1" :key="owl.id" :style="{backgroundImage: `url(${owl.src})`}" class="tourtheme hvr" @click="despkg(owl)">
                <h2 class="themecap">{{owl.name}}</h2>
               </v-card>
          </carousel>
     </div> -->


     <!-- ================================= -->
      <!-- ================================= -->

     <!-- <div style="margin-top:40px" class="res" v-if="owlCount3.length > 0">
       <p style="text-align:center;text-transform: uppercase;color:#0b89ef;font-weight:bold">
         T r a v e l  &nbsp;&nbsp;a n d  &nbsp;&nbsp;e a t  &nbsp;&nbsp;l i k e  &nbsp;&nbsp;a  &nbsp;&nbsp;l o c a l
       </p>
       <h2 style="text-align:center;margin-top:-15px">
         Top Most Trending International Destinations
       </h2>
       <carousel :autoplay="true" :items="5" :nav="false" :dots="false">
               <v-card v-for="owl in owlCount3" :key="owl.id" :style="{backgroundImage: `url(${owl.src})`}" class="tourtheme hvr" @click="despkg(owl)">
                <h2 class="themecap">{{owl.name}}</h2>
               </v-card>
          </carousel>
     </div>

     <div style="margin-top:40px" class="man" v-if="owlCount3.length > 0">
       <p style="text-align:center;text-transform: uppercase;color:#0b89ef;font-weight:bold">
         T r a v e l  &nbsp;&nbsp;a n d  &nbsp;&nbsp;e a t  &nbsp;&nbsp;l i k e  &nbsp;&nbsp;a  &nbsp;&nbsp;l o c a l
       </p>
       <h4 style="text-align:center;margin-top:-15px">
         Top Most Trending International Destinations
       </h4>
       <carousel :autoplay="true" :items="1" :nav="false" :dots="false">
               <v-card v-for="owl in owlCount3" :key="owl.id" :style="{backgroundImage: `url(${owl.src})`}" class="tourtheme hvr" @click="despkg(owl)">
                <h2 class="themecap">{{owl.name}}</h2>
               </v-card>
        </carousel>
     </div> -->

     

     <div style="margin-top:40px;padding-top:-200px;">
       <!-- <h2 class="res" style="text-align:center;margin-top:-15px">
         Popular Tour Packages
       </h2>
       <h4 class="man" style="text-align:center;margin-top:-15px">
        Popular Tour Packages
       </h4> -->

             <div class="section-heading">
        <div class="">
          <h2 class="res" style="text-align:center;margin-top:-15px">
         Domestic Tour Packages
       </h2>
       <h4 class="man" style="text-align:center;margin-top:-15px">
         Domestic Tour Packages
       </h4>
        </div>
        <div class="">
          <v-btn
                flat
                class="blue--text"
                @click="packages()"
                >
                  VIEW MORE&nbsp;<v-icon color="primary" :size="25">keyboard_arrow_right</v-icon>
              </v-btn>         
        </div>


      </div>

             <v-layout row wrap v-if="tourPackage.length > 0" >

          <v-flex xs12 md3 sm12 style="padding:20px" v-for="item in tourPackage" :key="item.id" >
            <v-card class="mx-auto" max-width="344" style="height: 420px;">
              <v-img :src=item.src height="200px" cover></v-img>
                  <div class="p-2">
                  <div style="height: 120px;">
                    <h4 class="mt-2">{{ item.name }}</h4>
                    <p>{{ item.city }}</p>
                  </div>
                    <div class="mx-2" >
                      <div class="row">
                        <div class="col" style="margin-top: 7px;">
                          <span style="padding: 15px;background-color: #034B93;border-radius: 50%;color: white;font-size: 18px;font-weight: bold;height: 10px;width: 10px;"><span v-if="item.day<10">0</span>{{ item.day }}</span> <span style="font-size:18px;"> Days</span>
                        </div>
                        <div class="col">
                          <v-btn
                            small
                            depressed
                            block
                            style="background-color:red;border-radius: 5px;"
                            class="white--text"
                            @click="view(item)"
                          >
                            View Details
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                 
                 <!-- <read-more :disabled="true" more-str="read more" :text="owl.description" link="#" less-str="read less" :max-chars="200"></read-more> -->
                 <!-- <div style="text-align:right;margin-top:-15px">
                   <v-btn small flat color="blue" @click="read(owl)">read more</v-btn>
                 </div> -->
                </v-card>
          </v-flex>

        </v-layout>

        <!-- <v-layout row wrap>
          <v-flex xs12 md3 sm12 style="padding:20px" v-for="owl in owlCount2" :key="owl.id">
            <v-card style="border-radius:0px;padding:0px" >
              <img :src=owl.src width="100%" height="200px"/>
              <v-card-title>
                <h4>{{owl.name}}</h4>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <p>{{owl.packageCount}} Packages</p>
              </v-card-title>
              <div style="text-align:center">
                           <v-btn
                            flat
                            class="blue--text"
                            @click="take(owl)"
                          >
                            TAKE ME THERE&nbsp;<v-icon color="primary" :size="25">keyboard_arrow_right</v-icon>
                          </v-btn>
               </div>
            </v-card>
          </v-flex>
        </v-layout> -->
     </div>
<!-- ************************************* INTERNATIONAL ******************************-->

     <div style="margin-top:40px">
       <!-- <h2 class="res" style="text-align:center;margin-top:-15px">
         Popular Tour Packages
       </h2>
       <h4 class="man" style="text-align:center;margin-top:-15px">
        Popular Tour Packages
       </h4> -->

             <div class="section-heading">
        <div class="">
          <h2 class="res" style="text-align:center;margin-top:-15px">
         International Tour Packages
       </h2>
       <h4 class="man" style="text-align:center;margin-top:-15px">
        International Tour Packages
       </h4>
        </div>
        <div class="">
          <v-btn
                flat
                class="blue--text"
                @click="packages()"
                >
                  VIEW MORE&nbsp;<v-icon color="primary" :size="25">keyboard_arrow_right</v-icon>
              </v-btn>         
        </div>


      </div>

             <v-layout row wrap v-if="tourPackage1.length > 0" >

              <v-flex xs12 md3 sm12 style="padding:20px" v-for="item in tourPackage1" :key="item.id" >
            <v-card class="mx-auto" max-width="344" style="height: 420px;">
              <v-img :src=item.src height="200px" cover></v-img>
                  <div class="p-2">
                  <div style="height: 120px;">
                    <h4 class="mt-2">{{ item.name }}</h4>
                    <p>{{ item.city }}</p>
                  </div>
                    <div class="mx-2" >
                      <div class="row">
                        <div class="col" style="margin-top: 7px;">
                          <span style="padding: 15px;background-color: #034B93;border-radius: 50%;color: white;font-size: 18px;font-weight: bold;height: 10px;width: 10px;"><span v-if="item.day<10">0</span>{{ item.day }}</span><span style="font-size:18px;"> Days</span>
                        </div>
                        <div class="col">
                          <v-btn
                            small
                            depressed
                            block
                            style="background-color:red;border-radius: 5px;"
                            class="white--text"
                            @click="view(item)"
                          >
                            View Details
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card>
          </v-flex>

        </v-layout>

        <!-- <v-layout row wrap>
          <v-flex xs12 md3 sm12 style="padding:20px" v-for="owl in owlCount2" :key="owl.id">
            <v-card style="border-radius:0px;padding:0px" >
              <img :src=owl.src width="100%" height="200px"/>
              <v-card-title>
                <h4>{{owl.name}}</h4>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <p>{{owl.packageCount}} Packages</p>
              </v-card-title>
              <div style="text-align:center">
                           <v-btn
                            flat
                            class="blue--text"
                            @click="take(owl)"
                          >
                            TAKE ME THERE&nbsp;<v-icon color="primary" :size="25">keyboard_arrow_right</v-icon>
                          </v-btn>
               </div>
            </v-card>
          </v-flex>
        </v-layout> -->
     </div>



     <!-- <div style="margin-top:40px">
      <div class="section-heading">
        <div class="">
          <h2 class="res" style="text-align:center;margin-top:-15px">
          Explore Hot Locations
       </h2>
       <h4 class="man" style="text-align:center;margin-top:-15px">
        Explore Hot Locations
       </h4>
        </div>
        <div class="">
          <v-btn
                            flat
                            class="blue--text"
                          >
                            VIEW MORE&nbsp;<v-icon color="primary" :size="25">keyboard_arrow_right</v-icon>
                          </v-btn>         
        </div>


      </div>
      <v-container style="max-width: 1400px;">
        <v-layout row wrap>

          <v-flex xs12 md3 sm12  >
            <v-card class="hot-tours-card" style="padding: 10px;    background-color: transparent;box-shadow: none;" >
              <div class="hot-tours">
                <div class="hot-tours-img">
                   <img  src="https://images.unsplash.com/photo-1433838552652-f9a46b332c40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="">
                </div>
                  <div class="title">
                      <h4>Miami</h4>
                      <v-spacer></v-spacer>
                      <v-spacer></v-spacer>
                      <p>4,090 properties</p>
                  </div>
              </div>
            </v-card>
          </v-flex>
          <v-flex xs12 md3 sm12  >
            <v-card class="hot-tours-card" style="padding: 10px;    background-color: transparent;box-shadow: none;" >
              <div class="hot-tours">
                <div class="hot-tours-img">
                   <img  src="https://images.unsplash.com/photo-1433838552652-f9a46b332c40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="">
                </div>
                  <div class="title">
                      <h4>Miami</h4>
                      <v-spacer></v-spacer>
                      <v-spacer></v-spacer>
                      <p>4,090 properties</p>
                  </div>
              </div>
            </v-card>
          </v-flex>
          <v-flex xs12 md3 sm12  >
            <v-card class="hot-tours-card" style="padding: 10px;    background-color: transparent;box-shadow: none;" >
              <div class="hot-tours">
                <div class="hot-tours-img">
                   <img  src="https://images.unsplash.com/photo-1433838552652-f9a46b332c40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="">
                </div>
                  <div class="title">
                      <h4>Miami</h4>
                      <v-spacer></v-spacer>
                      <v-spacer></v-spacer>
                      <p>4,090 properties</p>
                  </div>
              </div>
            </v-card>
          </v-flex>
          <v-flex xs12 md3 sm12  >
            <v-card class="hot-tours-card" style="padding: 10px;    background-color: transparent;box-shadow: none;" >
              <div class="hot-tours">
                <div class="hot-tours-img">
                   <img  src="https://images.unsplash.com/photo-1433838552652-f9a46b332c40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="">
                </div>
                  <div class="title">
                      <h4>Miami</h4>
                      <v-spacer></v-spacer>
                      <v-spacer></v-spacer>
                      <p>4,090 properties</p>
                  </div>
              </div>
            </v-card>
          </v-flex>
          <v-flex xs12 md3 sm12  >
            <v-card class="hot-tours-card" style="padding: 10px;    background-color: transparent;box-shadow: none;" >
              <div class="hot-tours">
                <div class="hot-tours-img">
                   <img  src="https://images.unsplash.com/photo-1433838552652-f9a46b332c40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="">
                </div>
                  <div class="title">
                      <h4>Miami</h4>
                      <v-spacer></v-spacer>
                      <v-spacer></v-spacer>
                      <p>4,090 properties</p>
                  </div>
              </div>
            </v-card>
          </v-flex>
          <v-flex xs12 md3 sm12  >
            <v-card class="hot-tours-card" style="padding: 10px;    background-color: transparent;box-shadow: none;" >
              <div class="hot-tours">
                <div class="hot-tours-img">
                   <img  src="https://images.unsplash.com/photo-1433838552652-f9a46b332c40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="">
                </div>
                  <div class="title">
                      <h4>Miami</h4>
                      <v-spacer></v-spacer>
                      <v-spacer></v-spacer>
                      <p>4,090 properties</p>
                  </div>
              </div>
            </v-card>
          </v-flex>
          <v-flex xs12 md3 sm12  >
            <v-card class="hot-tours-card" style="padding: 10px;    background-color: transparent;box-shadow: none;" >
              <div class="hot-tours">
                <div class="hot-tours-img">
                   <img  src="https://images.unsplash.com/photo-1433838552652-f9a46b332c40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="">
                </div>
                  <div class="title">
                      <h4>Miami</h4>
                      <v-spacer></v-spacer>
                      <v-spacer></v-spacer>
                      <p>4,090 properties</p>
                  </div>
              </div>
            </v-card>
          </v-flex>
          <v-flex xs12 md3 sm12  >
            <v-card class="hot-tours-card" style="padding: 10px;    background-color: transparent;box-shadow: none;" >
              <div class="hot-tours">
                <div class="hot-tours-img">
                   <img  src="https://images.unsplash.com/photo-1433838552652-f9a46b332c40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="">
                </div>
                  <div class="title">
                      <h4>Miami</h4>
                      <v-spacer></v-spacer>
                      <v-spacer></v-spacer>
                      <p>4,090 properties</p>
                  </div>
              </div>
            </v-card>
          </v-flex>

        
        </v-layout>
      </v-container>
    </div> -->
<!-- 
     <div style="margin-top:40px">
       <v-container  style="max-width: 1400px;">
        <v-layout row wrap>
          <v-flex xs12 md3 sm12 style="padding:20px" >
               <div class="box" >
                   <h1>4,958</h1>
                   <p>Destinations</p>
               </div>
          </v-flex>
          <v-flex xs12 md3 sm12 style="padding:20px" >
               <div class="box" >
                   <h1>2,869</h1>
                   <p>Total Properties</p>
               </div>
          </v-flex>
          <v-flex xs12 md3 sm12 style="padding:20px" >
               <div class="box" >
                   <h1>2M</h1>
                   <p>Happy customers</p>
               </div>
          </v-flex>
          <v-flex xs12 md3 sm12 style="padding:20px" >
               <div class="box" >
                   <h1>574,974</h1>
                   <p>Our Volunteers</p>
               </div>
          </v-flex>
        </v-layout>
       </v-container>
     </div> -->


     <div style="margin-top:40px">
        <v-layout row wrap>
          <v-flex xs12 md8 sm12 style="background-color: #3554d10d!important;"  >
            <div class="container p-5">

               <div class="row">
               <div class="col-lg-2">
              </div>

               <div class="col-lg-6">
                <div class="why-us" >
              <h1>Why Choose Us</h1>
               <p>These popular destinations have a lot to offer</p>
               </div>
               <div class="why-us-box">
                <div >
                  <img src="https://creativelayers.net/themes/gotrip-html/img/featureIcons/1/1.svg" alt="">

                </div>
                <div class="">
                  <h4>Best Price Guarantee</h4>
                  <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> -->
                </div>
               </div>
               <div class="why-us-box">
                <div >
                  <img src="https://creativelayers.net/themes/gotrip-html/img/featureIcons/1/2.svg" alt="">

                </div>
                <div class="">
                  <h4>Easy & Quick Booking</h4>
                  <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> -->
                </div>
               </div>
               <div class="why-us-box">
                <div >
                  <img src="https://creativelayers.net/themes/gotrip-html/img/featureIcons/1/3.svg" alt="">

                </div>
                <div class="">
                  <h4>Customer Care 24/7</h4>
                  <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> -->
                </div>
               </div>
               </div>
               <div class="col-lg-6">
                
              </div>
            </div>
            </div>

          </v-flex>
          <v-flex xs12 md4 sm12 class="why-us-img" >
            <img class="" src="https://creativelayers.net/themes/gotrip-html/img/backgrounds/5.png" alt="">
          </v-flex>
        </v-layout>
     </div>


      <!-- <div style="margin-top:40px"> -->
        <!-- <h2 class="res" style="text-align:center;margin-top:-15px">
         Get inspiration for your next trip
       </h2>
       <h4 class="man" style="text-align:center;margin-top:-15px">
         Get inspiration for your next trip
       </h4> -->
      <!-- <v-container style="max-width: 1400px;">

       <v-layout row wrap>
          <v-flex xs12 md4 sm12 style="padding:20px" >
            <v-card class="next-trip-card" style="  background-color: transparent;box-shadow: none;" >
               <div class="next-trip">
                <div class="next-trip-img">
                  <img class="" src="https://images.unsplash.com/photo-1621682372775-533449e550ed?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80" />
                </div>
                <div class="next-trip-title">
                  <h4>Booking travel during Corona: good advice in an uncertain time</h4>
                  <p>April 06, 2022</p>
                </div>
               </div>
                 
                </v-card>
          </v-flex>
          <v-flex xs12 md4 sm12 style="padding:20px" >
            <v-card class="next-trip-card" style="  background-color: transparent;box-shadow: none;" >
               <div class="next-trip">
                <div class="next-trip-img">
                  <img class="" src="https://images.unsplash.com/photo-1621682372775-533449e550ed?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80" />
                </div>
                <div class="next-trip-title">
                  <h4>Booking travel during Corona: good advice in an uncertain time</h4>
                  <p>April 06, 2022</p>
                </div>
               </div>
                 
                </v-card>
          </v-flex>
          <v-flex xs12 md4 sm12 style="padding:20px" >
            <v-card class="next-trip-card" style="  background-color: transparent;box-shadow: none;" >
               <div class="next-trip">
                <div class="next-trip-img">
                  <img class="" src="https://images.unsplash.com/photo-1621682372775-533449e550ed?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80" />
                </div>
                <div class="next-trip-title">
                  <h4>Booking travel during Corona: good advice in an uncertain time</h4>
                  <p>April 06, 2022</p>
                </div>
               </div>
                 
                </v-card>
          </v-flex>
        </v-layout>
      </v-container> -->

     <!-- </div> -->
  </v-app>
</template>

<script>
import config from "./../../config.json";
import carousel from 'vue-owl-carousel';
//import VueEasyLightbox from 'vue-easy-lightbox';
import GoTop from '@inotom/vue-go-top';

export default {
  components: {
    GoTop,
    carousel,
  },
  data() {
    return {
      valid: true,
      form: {
        tourPackage: null,
        destination: null
      },

      owlCount: [],

      owlCount1: [],

      owlCount3: [],

      owlCount2: [],

      mainOwl: [
      {
          "src": "https://bishnutoursandtravels.com/banner-1.png",
          // "name": "Start Your Travel Journey"
        },
        {
          "src": "https://bishnutoursandtravels.com/banner-2.png",
          // "name": "Find Great Deals & Travel Around The World"
        },
        {
          "src": "https://bishnutoursandtravels.com/banner-3.png",
          // "name": "Explore The World"
        },

      //   {
      //     "src": "https://api.bishnutoursandtravels.com/wwwroot/HomeBannerPic/banner-4.png",
      //  }
      ],
      tourPackage:[],
      tourPackage1:[],
      blogCount: []

    };
  },
  
   mounted() {
     this.axios
        .get(config.API + "Home", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          // console.log(res);
          this.owlCount = res.data;
          /* this.owlCount1 = res.data.domestic;
          this.owlCount3 = res.data.international;
          this.owlCount2 = res.data.hill;
          this.blogCount = res.data.blog; */
        });

        this.axios
        .get(config.API + "Home1", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          // console.log(res);
          this.owlCount1 = res.data;
        });

        this.axios
        .get(config.API + "Home2", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          // console.log(res);
          this.owlCount3 = res.data;
        });
        

        this.axios
        .get(config.API + "Home3", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          // console.log(res);
          this.owlCount2 = res.data;
        });

        this.axios
        .get(config.API + "Home4", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          // console.log(res);
          this.blogCount = res.data;
        });

        this.axios
        .get(config.API + "TourPackages1", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          console.log(res);

          let _list = res.data;

          for (let index = 0; index < _list.length; index++) {
            const element = _list[index];
            
            if(index < 8) {
              this.tourPackage.push(element)
            }
            
          }
        });

        this.axios
        .get(config.API + "TourPackages2", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          console.log(res);
          let _list = res.data;

          for (let index = 0; index < _list.length; index++) {
            const element = _list[index];
            
            if(index < 8) {
              this.tourPackage1.push(element)
            }
            
          }
        });
   },

 methods: {
   thmpkg(owl) {
     this.$router.push("/themePackage/" + owl.id);
   },
   despkg(owl) {
     this.$router.push("/destinationPackage/" + owl.id);
   },
   despkg1(owl) {
     this.$router.push("/destinationPackageInt/" + owl.id);
   },
   take(owl) {
     this.$router.push("/destinationPackage/" + owl.id);
   },
   read(owl) {
     this.$router.push("/blogDetails/" + owl.id);
   },
   view(des) {
      this.$router.push("/packageDetails/" + des.id);
    },
    packages() {
      this.$router.push("/packages");
    }
 }
};
</script>

<style scoped>
@import '../../HomeCss/home.css';

@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
</style>

<style scoped>
.banner {
  margin-top: 120px;
  background-size: contain;
  width: 100%;
  height:435px;
  box-shadow: none!important;

}

.tourtheme2 {
  margin: 15px;
  background-size: 100%;
  transition: background-size 1s ease-in-out !important;
  
}
.package-details {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.review {
  display:flex;
}
.rating-icon {
    display:flex;
    justify-content: space-around;
}
.tour-packages-img {
  max-width: 400px!important;

  max-height: 400px!important;
}
.tour-packages-img img {
  max-width: 400px!important;

  max-height: 400px!important;
}
.price {
  display: flex;
  justify-content: space-between;
}
.price-box p{
  margin-bottom: 5px;
  font-weight: 500;
}
.rating-icon img {
  height: 18px;
  margin-right: 3px;
}
.hot-tours-img  {
  overflow: hidden;
  height: 100px;
  width: 100px;
  border-radius: 5px;
  margin-right: 15px;
  margin-bottom: 10px;

}

.tour-packages-title p{
  margin-bottom:0px;
}
.hot-tours-img img {
  height: 100px;
  width: 100px;
transition: all 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.hot-tours-card:hover .hot-tours-img img {
  transform: scale(1.15);
}

.hot-tours-card:hover .tourtheme2 {
  background-size: 120%;
  transition-duration: 0.7s;
}
.hot-tours-card:hover .hot-tours .title h4 {
 color:#024C94;
}
.hvr2:hover {
  cursor: pointer;
  transition-duration: 0.7s;
  text-decoration: none !important;
}
.hot-tours {
  display: flex;
  align-items: center;
}
.next-trip-card{
  background-color: transparent!important;
}
.why-us-img img{
 max-width: 100%;
 max-height: 100%;
}
.why-us {
  margin-top: 40px;
}
.why-us p,.why-us-box p {
  color: #697488;

}
.why-us-box h4{
  margin-bottom: 0;
}
.why-us-box {
  display:flex;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 15px;
}
.why-us-box img {
  padding-right: 10px;
  height: 50px;
}
.next-trip-img {
  overflow: hidden;
  max-height: 350px;
  max-width:400px;
  border-radius: 5px;
  margin-right: 15px;
  margin-bottom: 10px;
}
.next-trip-img img {
  max-height: 350px;
  max-width:400px;
  transition: all 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);

}
.next-trip-card:hover .next-trip-img img {
  transform: scale(1.15);

}
.next-trip-title p {
  color: #a5a5a5;
}
.hot-tours .title {
  display: block;
}
.hot-tours .title p {
  font-size: 14px!important;
  color: #a5a5a5;
}
.box {
text-align: center;
}
.box h1 {
  color: #024C94;
}
.box p {
  color: #a5a5a5;
}

.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offsets {
  top: -50px;
  position: relative;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.v-sheet--offsetf {
  top: -100px;
  position: relative;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.tourtheme {
  height: 180px;
  border-radius: 0px;
  margin: 5px;
  background-size: cover;
}
.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.top-left {
  font-family: 'Metal Mania', cursive;
  font-size:60px ;
  padding-top: 230px;
  color: white;
  text-align: center;
}
.hvr:hover {
  cursor: pointer;
  /* height: 200px; */
  border : 3px solid;
  border-color: black;
}
.section-heading {
display: flex;
justify-content: space-around;
align-items: center;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
  .banner {
    height:150px;
  }
  .section-heading {
    flex-direction: column;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}

</style>
